export interface Product {
  id: number | string; // Peut être un number local ou un string (_id MongoDB)
  name: string;
  price: number;
  stock: number; // Alias local pour quantityAvailable (stock dispo pour le service)
  quantityAvailable?: number; // Stock disponible (backend)
  quantity?: number; // Setup de référence (backend)
  icon: string;
  category: ProductCategory;
  description?: string;
  imageUrl?: string;
  isActive: boolean;
  replacementProductId?: number | string;
  minStockAlert: number;
}

export enum ProductCategory {
  PLATS = 'Plats',
  DESSERTS = 'Desserts',
  BOISSONS = 'Boissons',
  SNACKS = 'Snacks',
}

export interface CartItem {
  id: string; // Identifiant unique de la ligne (timestamp + random)
  product: Product;
  quantity: number;
  isReplacement?: boolean;
  originalProductId?: number | string;
  originalProductName?: string;
}

export interface Cart {
  items: Map<string, CartItem>; // Clé = CartItem.id au lieu de product.id
  totalItems: number;
  totalPrice: number;
}

export interface Sale {
  id: number | string; // Peut être un number local ou un string (_id MongoDB)
  saleNumber: string;
  timestamp: Date;
  items: SaleItem[];
  totalAmount: number;
  status: SaleStatus;
  stockIssues?: StockIssue[];
  source?: 'kiosk' | 'manual'; // Source de la vente
}

export interface SaleItem {
  productId: number | string; // Peut être un number local ou un string (_id MongoDB)
  productName: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  isReplacement: boolean;
  originalProductId?: number | string;
}

export interface StockIssue {
  productId: number | string;
  productName: string;
  requestedQuantity: number;
  availableQuantity: number;
  replacementProductId?: number | string;
  replacementProductName?: string;
  alternativeProducts?: Product[];
}

export enum SaleStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  PARTIAL = 'partial',
}

export interface DailyStats {
  date: Date;
  totalSales: number;
  totalRevenue: number;
  averageBasket: number;
  topProducts: ProductPerformance[];
  stockAlerts: number;
  replacementStats?: ReplacementStats;
  categoryDistribution?: CategoryStat[];
  peakHour?: { hour: number; sales: number };
  stockSatisfactionRate?: number;
}

export interface ReplacementStats {
  totalReplacements: number;
  replacementRate: number; // Pourcentage d'articles remplacés
  topReplacedProducts: Array<{
    originalProductName: string;
    replacementProductName: string;
    count: number;
  }>;
}

export interface CategoryStat {
  category: ProductCategory;
  revenue: number;
  itemsSold: number;
  percentage: number;
}

export interface ProductPerformance {
  productId: number | string;
  productName: string;
  icon: string;
  quantitySold: number;
  revenue: number;
}

export interface StatsComparison {
  current: number;
  previous: number;
  percentageChange: number;
  trend: 'up' | 'down' | 'stable';
}
